var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nqContent" }, [
    _c(
      "div",
      { staticClass: "tiImgBox" },
      [
        _c(
          "swiper",
          {
            ref: "mySwiper",
            staticClass: "imgcases",
            attrs: {
              options: _vm.swiperOptionS,
              "slides-per-view": 3,
              "space-between": 50,
            },
            on: { swiper: _vm.onSwiper, slideChange: _vm.onSlideChange },
          },
          _vm._l(_vm.swiperList, function (item, i) {
            return _c("swiper-slide", { key: i }, [
              _c("div", { staticClass: "tjBox" }, [
                _c("div", { staticClass: "tjList" }, [
                  _c("img", {
                    staticStyle: { cursor: "pointer" },
                    attrs: { src: item.image_path },
                  }),
                  _c("div", { staticClass: "imgMsg" }, [
                    _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$formatDate(new Date(item.date), "yyyy-MM-dd")
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", { staticClass: "imgYuan" }),
                    _c("div", { staticClass: "imgLine" }),
                    _c("p", [_vm._v("数量: " + _vm._s(item.num) + "个")]),
                    _c("p", [
                      _vm._v(" " + _vm._s(item.growthPhase) + " "),
                      _c("span", { staticStyle: { "margin-left": "6px" } }, [
                        _vm._v("置信度: " + _vm._s(item.score)),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "recognise" },
                    _vm._l(item.signList, function (it, index) {
                      return _c("div", {
                        key: index,
                        staticClass: "signDiv",
                        style: {
                          left: it.location.left * _vm.w_ratio + "px",
                          top: it.location.top * _vm.h_ratio + "px",
                          width: it.location.width * _vm.w_ratio + "px",
                          height: it.location.height * _vm.h_ratio + "px",
                        },
                      })
                    }),
                    0
                  ),
                ]),
              ]),
            ])
          }),
          1
        ),
        _c("div", {
          staticClass: "swiper-button-next",
          on: { click: _vm.swiperNext },
        }),
        _c("div", {
          staticClass: "swiper-button-prev",
          on: { click: _vm.swiperPrev },
        }),
        _c("img", {
          staticClass: "bchLine",
          attrs: { src: _vm.bchLine, alt: "" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }